// GlobalStyles.jsx
import { createGlobalStyle } from "styled-components";

const pressStart2P = process.env.PUBLIC_URL + "/font/PixelFont.ttf";
const philosopher = process.env.PUBLIC_URL + "/font/Philosopher-Regular.ttf";
const monserat =
  process.env.PUBLIC_URL + "/font/Montserrat-VariableFont_wght.ttf";

const GlobalStyles = createGlobalStyle`
    /* 1 PixelFont */    
    @font-face {
        font-family: 'PixelFont'; 
        src: url("${pressStart2P}") format("truetype"); 
        font-weight: 400; 
        font-style: normal;
        font-display: swap; 
    }

    /* 2 Philosopher */
    @font-face {
        font-family: 'Philosopher'; 
        src: url(${philosopher}) format('truetype'); 
        font-weight: normal; 
        font-style: normal;
        font-display: swap; 
    }
    
    /* 3 Monserat */    
    @font-face {
        font-family: 'Monserat';
        src: url("${monserat}") format("truetype"); 
        font-weight: 400; 
        font-style: normal;
        font-display: swap; 
    }
    body {
        font-family: 'Monserat', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    
    .special-pixel-text {
        font-family: 'PixelFont', cursive;
        font-weight: 400 !important; 
        font-size: 1.5rem; 
        
        -webkit-font-smoothing: none; 
        -moz-osx-font-smoothing: grayscale;
        font-smoothing: none;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    
    img, a {
        filter: none !important;
        -webkit-filter: none !important;
        text-decoration: none;
    }
    
    body.dark-theme, html.dark-theme, body, html {
        filter: none !important;
        -webkit-filter: none !important;
        background-blend-mode: normal !important;
    }
`;

export default GlobalStyles;
